export const SAVE_FOR_LATER = "SAVE_FOR_LATER";
export const REMOVE_FROM_SAVE_FOR_LATER = "REMOVE_FROM_SAVE_FOR_LATER";
export const CLEAR_SAVE_FOR_LATER = "CLEAR_SAVE_FOR_LATER";